import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useItems, createItem, useBackendStatus } from '../data/firestore';
import { useAuth } from '../AuthContext';

// The demo domain page: a list of "items" (rename to whatever your app is
// about). Each item is a workspace with an S3 prefix, uploads and assets.

const fmtBytes = (n) => {
  if (!n) return '0 B';
  const u = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(n) / Math.log(1024));
  return `${(n / 1024 ** i).toFixed(1)} ${u[i]}`;
};

export default function Home() {
  const { user } = useAuth();
  const { docs: items } = useItems();
  const { doc: status } = useBackendStatus();
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);

  const backendLive = status?.heartbeat && Date.now() - status.heartbeat < 3 * 60 * 1000;

  return (
    <div className="cs-page">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <h1 style={{ margin: 0 }}>Items</h1>
        <span className="cs-help" title="configs/app heartbeat, written by the backend every minute">
          backend {backendLive ? '● online' : '○ offline'}
        </span>
      </div>

      {user && (
        <form
          style={{ display: 'flex', gap: 8, marginTop: 16, maxWidth: 480 }}
          onSubmit={async (e) => {
            e.preventDefault();
            if (!name.trim() || busy) return;
            setBusy(true);
            try {
              await createItem({ name: name.trim() });
              setName('');
            } finally {
              setBusy(false);
            }
          }}
        >
          <input
            className="cs-input"
            placeholder="New item name…"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <button className="cs-btn cs-btn-primary" disabled={!name.trim() || busy} type="submit">
            Create
          </button>
        </form>
      )}

      {items === null && <p className="cs-help" style={{ marginTop: 20 }}>Loading…</p>}
      {items && !items.length && (
        <div className="cs-empty" style={{ marginTop: 20 }}>
          Nothing here yet{user ? ' — create your first item above.' : ' — sign in to create one.'}
        </div>
      )}

      <div style={{ display: 'grid', gap: 10, marginTop: 18 }}>
        {(items || []).map((it) => (
          <Link key={it.id} to={`/items/${it.id}`} className="cs-card" style={{ padding: 14, textDecoration: 'none' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <strong style={{ color: 'var(--text)' }}>{it.name}</strong>
              <span style={{ flex: 1 }} />
              <span className="cs-help" style={{ fontSize: 12 }}>
                {it.assetCount || 0} asset{(it.assetCount || 0) === 1 ? '' : 's'} · {fmtBytes(it.totalBytes)}
              </span>
            </div>
            {it.description && <p className="cs-help" style={{ marginTop: 6 }}>{it.description}</p>}
          </Link>
        ))}
      </div>
    </div>
  );
}
